import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "lucide-react";

export default function StripeSuccess() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    localStorage.removeItem("pendingEmail");
    localStorage.removeItem("pendingPlan");
    localStorage.removeItem("pendingUserId");

    const timer = setTimeout(() => navigate("/profile"), 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-6">
      <div className="bg-white p-12 rounded-2xl shadow-sm text-center max-w-md">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        <h1 className="text-3xl font-serif text-gray-900 mb-3">
          {t("stripeSuccess.title")}
        </h1>
        <p className="text-neutral-600 mb-6">{t("stripeSuccess.description")}</p>
        <p className="text-sm text-neutral-500">{t("stripeSuccess.redirect")}</p>
      </div>
    </div>
  );
}
